<template>
  <div>
    <h6 class="title is-6">Create new password</h6>
    <div class="notification">
      <h3>Password Guidelines</h3>
      <strong>Strong</strong> = At least 1 symbol, 1 upper case, 1 lower case, 1
      number and more than 10 characters. <strong>Medium</strong> = At least 1
      symbol or number, either lowercase or upper case and more than 7
      characters. <strong>Weak</strong> = Insecure password.
    </div>
    <div class="columns">
      <div class="column is-4">
        <div class="field">
          <label class="label is-small">
            <span class="level">
              <span class="level-left">Password</span>
              <span class="level-right">
                &nbsp;
                <i>
                  <span
                    style="color:#37BC9B"
                    v-if="strengthNote === 'Strong'"
                    >{{ strengthNote }}</span
                  >
                  <span
                    style="color:#F6BB42"
                    v-if="strengthNote === 'Medium'"
                    >{{ strengthNote }}</span
                  >
                  <span style="color:#DA4453" v-if="strengthNote === 'Weak'">{{
                    strengthNote
                  }}</span>
                </i>
              </span>
            </span>
          </label>
          <div class="control">
            <input
              type="password"
              class="input is-small"
              v-validate="'required|min:7'"
              name="Password"
              v-model="password"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Password')
            }}</span>
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label is-small">Re-type Password</label>
          <div class="control">
            <input
              type="password"
              class="input is-small"
              v-validate="'required|min:7'"
              name="Confirm Password"
              v-model="confirmPassword"
            />
            <span style="font-size:12px" class="has-text-danger">{{
              errors.first('Confirm Password')
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        <button :class="isLoadingButton" @click="submit()">
          Submit
        </button>
        &nbsp;
        <button class="button" @click="closePage">Close</button>
      </div>
      <div class="level-right"></div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import AppToast from '../frontend/appToast'

const appToast = new AppToast()

export default {
  data: () => ({
    isLoadingButton: 'button is-success',
    password: '',
    confirmPassword: '',
    strengthNote: null,
    token: '',
    code: ''
  }),
  created() {
    this.token = this.$route.params.token
    this.code = this.$route.params.code

    if (this.token && this.code) {
      axios
        .patch(`api/resetpassword/validate/${this.token}/${this.code}`)
        .then(() => {
          // success and do nothing
        })
        .catch(error => {
          if (error.response) {
            appToast.danger(error.response.data)
            window.close()
          }
        })
    }
  },
  methods: {
    default() {
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    closePage() {
      window.close()
    },
    validatePasswordStrength(password) {
      var strongRegex = new RegExp(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})'
      )
      var mediumRegex = new RegExp(
        '^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})'
      )
      if (strongRegex.test(password)) {
        this.strengthNote = 'Strong'
      } else if (mediumRegex.test(password)) {
        this.strengthNote = 'Medium'
      } else {
        this.strengthNote = 'Weak'
      }
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.validatePasswordStrength(this.password)

          if (this.strengthNote === 'Weak') {
            appToast.danger(
              'Weak and Insecure password is not allowed. Please choose different password.'
            )
            return false
          }

          if (this.password !== this.confirmPassword) {
            appToast.danger("Confirm password doesn't match")
            return false
          }

          this.isLoadingButton = 'button is-success is-loading'

          axios
            .patch(
              `api/resetpassword/change/${this.token}/${this.code}/${this.password}`
            )
            .then(response => {
              appToast.success(response.data)

              setInterval(() => {
                window.close()
              }, 3000)
            })
            .catch(error => {
              if (error.response) {
                appToast.danger(error.response.data)
              }
            })
            .then(() => {
              this.isLoadingButton = 'button is-success'
            })
        }
      })
    }
  },
  watch: {
    password() {
      if (this.password) {
        this.validatePasswordStrength(this.password)
      } else {
        this.strengthNote = ''
      }
    }
  }
}
</script>
